import { IBlockchainEntity, ChainID } from '@ankr.com/chains-list';

import { getChainName as getFallbackChainsName } from 'uiKit/utils/metatags';

import { getChainLabel } from './getChainLabel';
import { getCustomLabelForChainsCornerCases } from './getCustomLabelForChainsCornerCases';

export const getChainName = (
  chain: IBlockchainEntity,
  shouldAvoidFormatting = true,
) => {
  if (chain.id === 'aapi_v2' || chain.id === ChainID.MULTICHAIN) {
    return 'Advanced API';
  }

  const chainId = chain.id as ChainID;

  const fallBackName = getFallbackChainsName(chainId);

  const label = getChainLabel(fallBackName, chain);

  const isZkVerifyChain =
    chain.id === ChainID.ZKVERIFY_VFLOW_PARACHAIN_TESTNET ||
    chain.id === ChainID.ZKVERIFY_VOLTA_TESTNET ||
    chain.id === ChainID.ZKVERIFY_VFLOW_PARACHAIN_MAINNET ||
    chain.id === ChainID.ZKVERIFY_MAINNET;

    const isTacSPBChain =
    chain.id === ChainID.TAC_TESTNET_SPB ||
    chain.id === ChainID.TAC_TESTNET_SPB_COSMOS_GRPC ||
    chain.id === ChainID.TAC_TESTNET_SPB_COSMOS_REST ||
    chain.id === ChainID.TAC_TESTNET_SPB_EVM ||
    chain.id === ChainID.TAC_TESTNET_SPB_TENDERMINT_REST ||
    chain.id === ChainID.TAC_TESTNET_SPB_TENDERMINT_RPC;

  const name = getCustomLabelForChainsCornerCases({
    chainId,
    label,
    shouldAvoidFormatting: shouldAvoidFormatting && (isZkVerifyChain || isTacSPBChain),
  });

  return name;
};
